import { ONE_SECOND } from './constants';

export const RESET_PASSWORD_TIMEOUT = ONE_SECOND * 3;
